<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'originsCrud'"
          :cruduser_id="$t('Origins')"
          :newText="$t('Add') + '  ' + $t('New')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "originsTable",
      showMessageImport: false,
      originsCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "title",
        "description",
        "order",
        "actions",
      ],
      tableData: [
        "id",
        "title",
        "description",
        "order",
      ],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id","title", "description","order"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t("id"),
          title: this.$t("title"),
          description: this.$t("description"),
          order: this.$t("order"),
          actions: this.$t("action"),
        },

        texts: {
          filterBy: this.$t("Filter"),
          defaultOption: this.$t("Select"),
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "origins",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        title: this.$t("title"),
        description: this.$t("description"),
        order: this.$t("order"),
        actions: this.$t("action"),
      };
      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        description: "description",
        order: "order",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {},
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
